module.exports = __webpack_public_path__ + "static/media/call-waiting-sound.17fcdaf0.mp3";